import styles from "./BlogHeader.module.scss";

export default function BlogHeader({ heading, content, className }) {
  const classNames = [styles["BlogHeader"], className].join(" ");

  return (
    <div className={classNames}>
      {heading && <h1 className={styles["BlogHeader__heading"]}>{heading}</h1>}
      {content && <p className={styles["BlogHeader__content"]}>{content}</p>}
    </div>
  );
}
